export { default } from "./TextualTile";
